import { faPause, faPlay } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import ReactPlayer from 'react-player';
import { videoDuration } from './EditVideo.css';
import { getFfmpegTimeFormat } from '../../helpers';

export type CustomPlayerProps = {
  src: string;
  duration: number;
  poster?: string;
  className?: string;
  style?: React.CSSProperties;
  width?: number | string;
  height?: number | string;
  hideDuration?: boolean;
};

export const Player = ({
  src,
  duration,
  poster,
  className,
  style,
  width,
  height,
  hideDuration,
}: CustomPlayerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const togglePlay = () => setIsPlaying((prev) => !prev);
  const openAndPlay = () => {
    setIsOpen(true);
    setIsPlaying(true);
  };

  if (!isOpen) {
    return (
      <div onClick={openAndPlay} className="relative h-full flex">
        <img
          src={poster}
          width={width}
          height={height}
          loading="lazy"
          style={{ maxHeight: height, maxWidth: width, objectFit: 'contain' }}
        />
        <button className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-full bg-gray-400 bg-opacity-50 w-[40px] h-[40px]">
          <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} color="white" />
        </button>
        {hideDuration ? null : (
          <div className={videoDuration}>{getFfmpegTimeFormat(duration)}</div>
        )}
      </div>
    );
  }

  return (
    <div className={className + ' relative'} onClick={togglePlay}>
      <ReactPlayer
        playing={isPlaying}
        playsinline
        width={width}
        height={height}
        url={src}
        config={{ file: { attributes: { poster } } }}
        playIcon={<FontAwesomeIcon icon={faPlay} />}
        onEnded={() => setIsPlaying(false)}
        controls={isPlaying}
        style={{
          borderRadius: '6px',
          overflow: 'hidden',
          ...style,
        }}
      />
      {!isPlaying ? (
        <button className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-full bg-gray-400 bg-opacity-50 w-[40px] h-[40px]">
          <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} color="white" />
        </button>
      ) : null}
      {!isPlaying && !hideDuration ? (
        <div className={videoDuration}>{getFfmpegTimeFormat(duration)}</div>
      ) : null}
    </div>
  );
};
